import { Component, Input } from '@angular/core';
import { MobileInformation } from 'src/app/interfaces/mobile-informations';

@Component({
  selector: 'mobile-informations',
  templateUrl: './mobile-informations.component.html',
  styleUrls: ['./mobile-informations.component.scss'],
})
export class MobileInformationsComponent {
  constructor() {}
  @Input() mobileInformations: MobileInformation[];
}
